import { Device } from '@/store/device/types';
import { Prices } from '@/store/prices/types';
import getParamAsString from '@/utils/getParamsAsString';
import isFirstMonthCoupon from '@/utils/prices/isFirstMonthCoupon';
import isUSPricing from '@/utils/prices/isUSPricing';

type PricesQuery = Record<string, string | string[] | undefined>;

/**
 * Prices fetched with the first-month coupon are discounted even where the offer is not sold,
 * while checkout drops that coupon outside US pricing. Refetching without it keeps the quoted
 * price equal to the price charged.
 */
export async function withoutUnofferedFirstMonthPrices({
	prices,
	device,
	query,
	refetch,
}: {
	prices: Prices | null;
	device: Device | null | undefined;
	query: PricesQuery;
	refetch: (query: PricesQuery) => Promise<Prices | null>;
}): Promise<Prices | null> {
	const monthly = prices?.coupons?.monthly;
	if (
		!prices ||
		!isFirstMonthCoupon(monthly) ||
		monthly.id !== getParamAsString(query.coupon) ||
		isUSPricing(prices, device)
	) {
		return prices;
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { coupon, ...queryWithoutCoupon } = query;
	return refetch(queryWithoutCoupon);
}
